import { atom } from "jotai";

/**
 * Atom used to request programmatic navigation to a component panel in the DESIGN tab.
 * Set to a component name (e.g. "genset", "load") to trigger navigation.
 * The LoadProject component listens to this atom and resets it after acting.
 */
export const navigateToComponentAtom = atom(null);
